module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "auto-wrapper"
  }, [_c('div', {
    staticClass: "auto-top-bar"
  }, [_c('div', {
    staticClass: "auto-top-inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    ref: "input",
    staticClass: "auto-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "auto-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('onCancel')
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    staticClass: "auto-list-wrapper"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('ul', {
    staticClass: "auto-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "auto-list-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.onItemClick(index)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.field]))])])
  }))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-389d6cf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/autocomplete/autocomplete.vue
// module id = 345
// module chunks = 1